module.exports = __webpack_public_path__ + "img/ic24PetGender.a3c1dd4b.svg";